import { useState } from "react";
import Link from "next/link";

import {
  CommonAPI,
  CommonSessionDetails,
  SessionDetails,
} from "@bagel-web/common";
import { CopyValue, Inspector } from "@bagel-web/components";

const SessionLink = ({
  sessionId,
  commonAPI,
  disableLink = false,
}: {
  sessionId: string;
  commonAPI: CommonAPI;
  disableLink?: boolean;
}) => {
  const [session, setSession] = useState<CommonSessionDetails | null>(null);

  const handlePreviewSession = async () => {
    if (session) {
      return;
    }
    const sessionData = await commonAPI.fetchSession(sessionId);
    setSession(sessionData);
  };

  return (
    <Inspector
      View={SessionDetails}
      viewProps={{ session: session || null }}
      onEnter={handlePreviewSession}
      showLoading={!session}
    >
      {disableLink ? (
        <CopyValue>{sessionId}</CopyValue>
      ) : (
        <Link href={`/sessions/${sessionId}`}>
          <code>{sessionId}</code>
        </Link>
      )}
    </Inspector>
  );
};

export default SessionLink;
